<template>
  <table class="rush-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" rowspan="2">
          <input type="checkbox" v-model="allSelected" class="mr-2">
          Id
        </th>
        <th scope="col" rowspan="2">Audience</th>
        <th scope="col" rowspan="2">Status</th>
        <th scope="col" colspan="2" class="text-center">Start</th>
        <th scope="col" rowspan="2">Remaining time</th>
        <th scope="col" colspan="2" class="text-center">Finish</th>
        <th scope="col" rowspan="2" v-if="mayManageRush">Actions</th>
      </tr>
      <tr>
        <th scope="col">planned</th>
        <th scope="col">real</th>
        <th scope="col">planned</th>
        <th scope="col">real</th>
      </tr>
    </thead>
    <tr
      v-for="container in containers"
      :key="container.rush.id"
      :class="getRushClass(container.rush.status)"
    >
      <td>
        <input type="checkbox" v-model="container.selected" class="mr-2">
        <rush-link :rushId="container.rush.id" label=""/>
      </td>
      <td>
        <span v-b-popover.hover.top="getPlayerGroupDescription(container.rush.playerGroupId)">
          {{ container.rush.playerGroupId | getPlayerGroupName }}
        </span>
      </td>
      <td :class="getRushStatusClass(container.rush.status)">
        {{ container.rush.status | getRushStatusName }}
      </td>

      <td>{{ container.rush.stime | getMomentMinStr }}</td>
      <td>{{ container.rush.srtime | getRushRealStartTimeStr }}</td>

      <td>{{ getRemainingTimeStr(container.rush) }}</td>

      <td>{{ container.rush.ftime | getMomentMinStr }}</td>
      <td>{{ container.rush.frtime | getRushRealFinishTimeStr }}</td>

      <td v-if="mayManageRush" class="action-box">
        <b-button
          v-if="isFinishButtonVisible(container.rush.status)"
          @click="finishRush(container.rush)"
          variant="warning"
          size="sm"
        >
          Finish
        </b-button>

        <b-button
          @click="deleteRush(container.rush.id)"
          variant="danger"
          size="sm"
        >
          Delete
        </b-button>
      </td>
    </tr>
  </table>
</template>

<script>
import { getPlayerGroupName        } from '../model/event.js';
import { getPlayerGroupDescription } from '../model/event.js';

/**
 * @typedef { import('../model/rush.js').RushStatus } RushStatus
 */

import { getRushStatusName        } from '../model/rush.js';
import { getRushStatusClass       } from '../model/rush.js';
import { getRushRealStartTimeStr  } from '../model/rush.js';
import { getRushRealFinishTimeStr } from '../model/rush.js';
import { getRushRemainingTimeStr  } from '../model/rush.js';
import { isRushActive             } from '../model/rush.js';
import { isRushClosed             } from '../model/rush.js';

import RushLink from './RushLink.vue';

export default {
  name: 'RushTable',

  components: {
    RushLink,
  },

  props: {
    containers: {
      type: Array,
      required: true,
    },

    nowSec: {
      type: Number,
      required: true,
    },

    mayManageRush: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    allSelected: {
      get() {
        for(const container of this.containers) {
          if(!container.selected) {
            return false;
          }
        }
        return true;
      },

      set(newValue) {
        if(newValue) {
          this.selectAll();
        } else {
          this.deselectAll();
        }
      },
    },
  },

  methods: {
    getPlayerGroupDescription,
    getRushStatusClass,

    getRushClass(status) {
      return {
        closed: isRushClosed(status)
      };
    },

    getRemainingTimeStr(rush) {
      return getRushRemainingTimeStr(rush, this.nowSec);
    },

    selectAll() {
      this.$emit('rushes-selection-requested');
    },

    deselectAll() {
      this.$emit('rushes-deselection-requested');
    },

    //-------------------------------------------------------------------------
    // Finish
    //-------------------------------------------------------------------------

    /**
     * @param {RushStatus} status
     * @returns {boolean}
     */
    isFinishButtonVisible(status) {
      return isRushActive(status);
    },

    finishRush(rush) {
      this.$emit('rush-finalization-requested', rush);
    },

    //-------------------------------------------------------------------------

    /** @param {number} rushId */
    deleteRush(rushId) {
      this.$emit('rush-deletion-requested', rushId);
    },
  },

  filters: {
    getPlayerGroupName,
    getRushStatusName,
    getRushRealStartTimeStr,
    getRushRealFinishTimeStr,
  },
};
</script>

<style scoped>
.rush-table {
  width: 1px;
}

.closed {
  color: #dcdcdc;
}

.action-box {
  padding: 7px;
  vertical-align: middle;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
